var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNotification({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0.3 2.5 19.5 19.5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 6.2C15.75 5.52 15.05 5.08 14.43 5.35L7.7 8.25H5.45C4.12 8.25 3.05 9.32 3.05 10.65V11.35C3.05 12.68 4.12 13.75 5.45 13.75H7.7L14.43 16.65C15.05 16.92 15.75 16.48 15.75 15.8V6.2Z",
    stroke: "#7E808F",
    strokeWidth: 1.05,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.35 13.75L4.85 18.15C4.77 18.82 5.28 19.45 5.96 19.45H7.15C7.76 19.45 8.22 18.92 8.12 18.32L7.65 13.75",
    stroke: "#7E808F",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 9.81A1.2 1.2 0 1 1 15.75 12.19",
    stroke: "#7E808F",
    strokeWidth: 1.05,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotification);
export default __webpack_public_path__ + "static/media/iconNotification.83771767245eeb4ecbb6f64c4fa69937.svg";
export { ForwardRef as ReactComponent };